/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_DescriptionInputs */

const en_to_csv_description = /** @type {(inputs: To_Csv_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert JSON arrays to CSV format online. Transform your JSON data into downloadable CSV spreadsheets.`)
};

const ko_to_csv_description = /** @type {(inputs: To_Csv_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 배열을 CSV 형식으로 온라인 변환하세요. JSON 데이터를 스프레드시트로 변환합니다.`)
};

const ja_to_csv_description = /** @type {(inputs: To_Csv_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON配列をCSV形式にオンライン変換。JSONデータをスプレッドシートに変換します。`)
};

/**
* | output |
* | --- |
* | "Convert JSON arrays to CSV format online. Transform your JSON data into downloadable CSV spreadsheets." |
*
* @param {To_Csv_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_description = /** @type {((inputs?: To_Csv_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_description(inputs)
	if (locale === "ko") return ko_to_csv_description(inputs)
	return ja_to_csv_description(inputs)
});